import {Inject, Injectable} from '@angular/core';
import {EdlForm} from '../components/form-builder/models/edl-form.model';
import { CplItem } from '../model/cpl-item.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CplQfmDuplicateData } from '../model/cpl-qfm-duplicate-data.model';
import { BaseApi, BASE_URL } from '@edl-development/edl-common';
@Injectable()
export class QuestionnaireApi extends BaseApi {
    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getQuestionnairesForPortal({
        portalId,
        availability,
        offset,
        limit,
        orderBy,
        ascending,
        searchBy,
        status
    } : {
        portalId: number,
        availability: number,
        offset?: number,
        limit?: number,
        orderBy?: string,
        ascending?: boolean,
        searchBy?: string,
        status?: number       
    }) {
        const params = new HttpParams()
            .append('offset', String(offset))
            .append('limit', String(limit))
            .append('orderBy', String(orderBy))
            .append('ascending', String(ascending))
            .append('searchBy', this.convertParam(searchBy))
            .append('status', String(status));

        return this.http.get(this.baseUri + '/Questionnaires/Portal/' + portalId.toString() + "/" + availability.toString(), {
            params
        });
    }

    getQuestionnaireById(id: string) {
        return this.http.get(this.baseUri + '/Questionnaire/' + id);
    }

    saveQuestionnaire(questionnaire: EdlForm) {
        return this.http.post(this.baseUri + '/Questionnaire', questionnaire);
    }

    deleteQuestionnaire(questionnaire: EdlForm) {
        return this.http.request('delete', this.baseUri + '/Questionnaire', {
            responseType: 'text',
            body: questionnaire
        });
    }

    restoreQuestionnaire(questionnaire: EdlForm) {
        return this.http.post(this.baseUri + '/Questionnaire/Restore', questionnaire, { responseType: 'text' });
    }

    removeQuestionnaire(questionnaire: EdlForm) {
        return this.http.request('delete', this.baseUri + '/Questionnaire/Remove', {
            responseType: 'text',
            body:questionnaire
        });
    }

    activateQuestionnaire(questionnaire: EdlForm) {
        return this.http.post(this.baseUri + '/Questionnaire/activate', questionnaire, { responseType: 'text' });
    }

    archiveQuestionnaire(questionnaire: EdlForm) {
        return this.http.post(this.baseUri + '/Questionnaire/Archive', questionnaire, { responseType: 'text' });
    }

    convertQuestionnaireToTemplate(questionnaire: EdlForm) {
        return this.http.post(this.baseUri + '/Questionnaire/ConvertToTemplate', questionnaire);
    }

    duplicateQuestionnaire(data: CplQfmDuplicateData) {
        return this.http.post(this.baseUri + '/Questionnaire/Duplicate', data);
    }

    getUserForm(userFormId: string) {
        return this.http.get(this.baseUri + '/Questionnaire/UserForm/' + userFormId);
    }

    createUserFormIfNotExist(userRequestId: string, qfmId: string) {
        return this.http.post(this.baseUri + '/Questionnaire/UserForm/CreateIfNotExist', {
            userRequestId,
            qfmId
        });
    }

    getUserFormHistory(userFormId: any, historyId: number) {
        return this.http.get(this.baseUri + '/Questionnaire/UserForm/' + userFormId+'/history/'+historyId);
    }

    completeQuestionnaire(payload: Object) {
        return this.http.post(this.baseUri + '/Questionnaire/UserForm', payload, { responseType: 'text' });
    }

    getQfmUsageReport(complianceItem: CplItem){
        return this.http.get(this.baseUri + '/Questionnaire/usagereport/' + complianceItem.ItemID, {
            responseType: 'blob'
        });
    }

    getCycleQuestionnaireUsage(ItemID: string, cycleId: string): any {
        return this.http.get(this.baseUri + '/Questionnaire/usagereport/cycle/' + ItemID+"/"+ cycleId, {
            responseType: 'blob'
        });
    }
    getCurrentCycleQuestionnaireUsage(ItemID: string): any {
        return this.http.get(this.baseUri + '/Questionnaire/usagereport/latest/' + ItemID, {
            responseType: 'blob'
        });
    }
    getAllQuestionnaireUsage(ItemID: string): any {
        return this.http.get(this.baseUri + '/Questionnaire/usagereport/' + ItemID, {
            responseType: 'blob'
        });
    }

    getRequestQuestionnaireUsage(requestID: string, qfmID: string, followup: number) {
        return this.http.get(this.baseUri + '/Questionnaire/usagereport/request/' + requestID + "/" + qfmID + "/" + followup, {
            responseType: 'blob'
        });
    }

    getQuestionnairesForRequest(requestId: string) {
        return this.http.get(this.baseUri + '/Questionnaires/Request/' + requestId);
    }

    recalculate(payload: Object) {
        return this.http.post(this.baseUri + '/Questionnaire/UserForm/Recalculate', payload);
    }
}